import * as React from 'react';
import { LocationDescriptor } from 'history';
import { 
  IButtonProps, 
  buttonClassNames,
  wrapButtonChildren
} from '.';
import { Link } from 'react-router-dom';

export interface ILinkButtonProps extends IButtonProps {
  to: LocationDescriptor;
  replace?: boolean;
  innerRef?: (node: HTMLAnchorElement | null) => void;
}

const LinkButton = (props: ILinkButtonProps) => (
  <Link 
    to={props.to} 
    className={buttonClassNames(props)}
    replace={props.replace}
    innerRef={props.innerRef}
  >
    {wrapButtonChildren(props.children)}
  </Link>
);

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/Button/LinkButton.tsx